import { render } from "./ClientsBirthdayMonth.vue?vue&type=template&id=302493f9&ts=true"
import script from "./ClientsBirthdayMonth.vue?vue&type=script&lang=ts"
export * from "./ClientsBirthdayMonth.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__